import React from 'react';
import { PlusIcon, PanelLeftIcon } from 'lucide-react';
import { SidebarSection } from './SidebarSection';
import { UserProfile } from './UserProfile';
import { AssistantSelector } from './AssistantSelector';
import { FloatingButton } from './FloatingButton';
import { mockData } from '../utils/mockData';
import { Link, useLocation } from 'react-router-dom';
interface SidebarProps {
  currentAssistant: string;
  onAssistantChange: (assistant: string) => void;
  isCollapsed: boolean;
  onToggleCollapse: () => void;
}
export const Sidebar = ({
  currentAssistant,
  onAssistantChange,
  isCollapsed,
  onToggleCollapse
}: SidebarProps) => {
  const location = useLocation();
  const SidebarLink = ({
    to,
    children
  }: {
    to: string;
    children: React.ReactNode;
  }) => <Link to={to} className={`block p-2 mb-1 rounded text-sm truncate hover:bg-[#333333] transition-colors ${location.pathname === to ? 'bg-[#2a2a2a]' : ''}`} data-id="element-175">
      {children}
    </Link>;
  return <>
      {isCollapsed ? <FloatingButton onClick={onToggleCollapse} data-id="element-176" /> : <aside className="w-[300px] bg-[#1f1f1f] flex flex-col border-r border-[#444444] transition-all duration-300" data-id="element-177">
          <div className="h-12 px-2 flex items-center gap-2 border-b border-[#444444]" data-id="element-178">
            <button onClick={onToggleCollapse} className="p-2 hover:bg-[#2a2a2a] rounded-lg transition-colors" title="Collapse sidebar" data-id="element-179">
              <PanelLeftIcon size={20} className="text-[#888888]" data-id="element-180" />
            </button>
            <div className="flex-grow flex items-center gap-2 w-6 h-6" data-id="element-181"></div>
            <button className="flex items-center gap-2 bg-[#4a90e2] text-white py-1.5 px-3 rounded-md text-sm font-medium transition-colors hover:bg-[#3a7bc2]" data-id="element-182">
              <PlusIcon size={14} data-id="element-183" />
            </button>
          </div>
          <AssistantSelector currentAssistant={currentAssistant} onAssistantChange={onAssistantChange} data-id="element-184" />
          <nav className="flex-grow overflow-y-auto px-2 pb-4" data-id="element-185">
            <SidebarSection title="Chat History" defaultOpen={true} data-id="element-186">
              <ul data-id="element-187">
                {mockData.sidebar.chatHistory.map(item => <li key={item.id} data-id="element-188">
                    <SidebarLink to={`/chat/${item.id}`} data-id="element-189">
                      {item.title}
                    </SidebarLink>
                  </li>)}
              </ul>
            </SidebarSection>
            <SidebarSection title="Active Investigations" defaultOpen={true} data-id="element-190">
              <ul data-id="element-191">
                {mockData.sidebar.activeInvestigations.map(item => <li key={item.id} data-id="element-192">
                    <SidebarLink to={`/chat/${item.id}`} data-id="element-193">
                      {item.title}
                    </SidebarLink>
                  </li>)}
              </ul>
            </SidebarSection>
            <SidebarSection title="Active Incidents" defaultOpen={true} data-id="element-194">
              <ul data-id="element-195">
                {mockData.sidebar.activeIncidents.map(item => <li key={item.id} data-id="element-196">
                    <SidebarLink to={`/chat/${item.id}`} data-id="element-197">
                      {item.title}
                    </SidebarLink>
                  </li>)}
              </ul>
            </SidebarSection>
            <SidebarSection title="Bodycam Footage" defaultOpen={true} data-id="element-198">
              <ul data-id="element-199">
                {mockData.sidebar.bodycamFootage.map(item => <li key={item.id} data-id="element-200">
                    <SidebarLink to={`/transcript/${item.id}`} data-id="element-201">
                      {item.title}
                    </SidebarLink>
                  </li>)}
              </ul>
            </SidebarSection>
            <SidebarSection title="Archived" defaultOpen={false} data-id="element-202">
              <ul data-id="element-203">
                {mockData.sidebar.archived.map(item => <li key={item.id} data-id="element-204">
                    <SidebarLink to={`/chat/${item.id}`} data-id="element-205">
                      {item.title}
                    </SidebarLink>
                  </li>)}
              </ul>
            </SidebarSection>
          </nav>
          <UserProfile data-id="element-206" />
        </aside>}
    </>;
};